import { simplifiedWeekDaysNames } from '../../../commom/weekDaysNames';
import { Typography } from '../Typography';

interface iWeekCalendarDayButtonProps {
  date: Date;
  selected?: boolean;
  onClick?: () => void;
}

function WeekCalendarDayButton({
  date,
  selected = false,
  onClick,
}: iWeekCalendarDayButtonProps) {
  const day = date.getDate();
  const weekDay = simplifiedWeekDaysNames[date.getDay()];

  return (
    <div
      className={`flex grow flex-col items-center gap-sm rounded-md py-2 hover:cursor-pointer hover:bg-color-lightest ${
        selected ? 'bg-color-lightest' : ''
      }`}
      onClick={onClick}
    >
      <Typography size='small'>{weekDay}</Typography>
      <Typography type='title' size='h3'>
        {day}
      </Typography>
    </div>
  );
}

export { WeekCalendarDayButton };
